import CountDownMessage from './CountDownMessage';

export default CountDownMessage;
